module.exports = __webpack_public_path__ + "static/img/platform-demo2.9aeb7e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/platform/platform-demo2.png
// module id = McNc
// module chunks = 0